import { useEffect, useContext, useState, FC, useMemo } from 'react'
import { useRouter } from 'next/router'

import { AlertType, AlertTypeKeyString } from 'AlertsOfVulnerability/types'
import readAlertsTypesGlobal from 'services/calls/global/alertsTypes/readAlertsTypesGlobal'
import { getModuleByPathOnURL } from 'utils/module'
import AlertsTypesForFilterManagerContext from './Context'

type Props = {
  readAlertsTypesFromSpecifRoute?: (params?: any) => Promise<any>
  children: JSX.Element
}

const AlertsTypesForFilterManagerProvider: FC<Props> = ({ readAlertsTypesFromSpecifRoute, children }) => {
  const [loadingAlertsTypes, setLoadingAlertsTypes] = useState(true)
  const [alertsTypes, setAlertsTypes] = useState<AlertType[]>([])
  const [selectAlertType, setSelectAlertType] = useState<AlertTypeKeyString>({})

  const { asPath } = useRouter()

  const MODULE = useMemo(() => {
    const moduleOnUrl = asPath.split('/')[1]
    return getModuleByPathOnURL(moduleOnUrl)
  }, [asPath])

  const getAlertsTypesFromAnotherRoute = async () => {
    if (!readAlertsTypesFromSpecifRoute) return
    const response = await readAlertsTypesFromSpecifRoute()
    if (response?.header?.success) {
      const alertsTypesFromAPI = response?.body?.case_type?.elements || response?.body?.case_type
      setAlertsTypes(alertsTypesFromAPI)
    }
  }

  const getAlertsTypes = async () => {
    const response = await readAlertsTypesGlobal({ MODULE })
    if (response?.header?.success) {
      const alertsTypesFromAPI = response?.body?.case_type?.elements || response?.body?.case_type
      setAlertsTypes(alertsTypesFromAPI)
    }
  }

  async function reloadAlertsTypes() {
    setLoadingAlertsTypes(true)
    if (readAlertsTypesFromSpecifRoute) {
      await getAlertsTypesFromAnotherRoute()
    } else {
      await getAlertsTypes()
    }

    setLoadingAlertsTypes(false)
  }

  useEffect(() => {
    reloadAlertsTypes()
  }, [])

  return (
    <AlertsTypesForFilterManagerContext.Provider
      value={{
        loadingAlertsTypes,
        alertsTypes,
        selectAlertType,
        setSelectAlertType,
      }}
    >
      {children}
    </AlertsTypesForFilterManagerContext.Provider>
  )
}

export const useAlertsTypesForFilterManager = () => useContext(AlertsTypesForFilterManagerContext)

export default AlertsTypesForFilterManagerProvider
